import { useQuery } from '@tanstack/react-query';

import { getAssignedSubprojectsForKpi } from '@/features/projects/project-details/api/get-assigned-subprojects-for-kpi';

export const getAssignedSubprojectsForKpiQueryKey = (kpiId: number) => [
  'assignedSubprojectsForKpi',
  kpiId,
];

export const useAssignedSubprojectsForKpi = (kpiId: number) => {
  return useQuery({
    queryKey: getAssignedSubprojectsForKpiQueryKey(kpiId),
    queryFn: () => getAssignedSubprojectsForKpi(kpiId),
    enabled: !!kpiId,
  });
};
